import {Component} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {UserInfoService} from '../../../services/user-info.service';
import {LoaderComponent} from '../../../core/loader/loader.component';

@Component({
    selector: 'vr-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.scss'],
})

export class LogoutComponent {
    dialogRef: MatDialogRef<LoaderComponent>;
    result: string;

    constructor(private userInfoService: UserInfoService, private dialog: MatDialog) {
        sessionStorage.clear();
        this.userInfoService.removeUserInfo();
        this.userInfoService.removeRoles();
        this.dialog.closeAll();
    }
}
